<template>
  <v-container fluid class="mx-7 mt-6">
    <validation-observer ref="observer" v-slot="{ invalid }">
      <base-material-card
        inline
        icon="mdi-poll"
        color="primary"        
        class="px-5 py-4 ml-0"
      >
        <template v-slot:after-heading>
          <div class="display-2 font-weight-light">
            {{title}}
          </div>
        </template>
        <v-form class="pt-5">
          <parametros ref="parametrosREF" />
          <v-row>
            <v-col />
            <v-col cols="12" md="6">
              <v-btn
                id="btn-save-projecao-brr"
                color="success"
                min-width="100"
                style="float: right"
                class="mt-5 mr-0"
                :disabled="invalid"
                :loading="loading"
                @click="salvar()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </base-material-card>
    </validation-observer>
  </v-container>
</template>
  
<script>
import ProjecaoBrrService from '@/services/ProjecaoBrrService';
import dateFormatterMixins from '@/mixins/dateFormatterMixins';
import tourMixins from '@/mixins/tourMixins';

export default {
  mixins: [dateFormatterMixins, tourMixins],

  components: {
    Parametros: () => import("@/components/projecaoBrr/Parametros.vue")
  },

  created() {
    this.$store.dispatch('clearProjecaoBrr');
  },
  
  mounted() {
    if (this.$route.params.id) this.getById(this.$route.params.id);
    this.iniciarTourPagina();
  },
  
  data: () => ({
    loading: false,
    arrTour: [
      {
        element: '#titulo-projecao-brr',
        intro: 'Aqui você poderá inserir um nome para sua Projeção de Brr.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: '#select-movimentacao-blindada',
        intro: 'Aqui você poderá selecionar qual Movimentação da Base Homologada deseja utilizar na sua Projeção de Brr.',
        scrollTo: "tooltip",
        position: 'left'
      },
      {
        element: '#select-simulacao-laudo-express',
        intro: 'Aqui você poderá selecionar qual Simulação de Laudo Express deseja utilizar na sua Projeção de Brr.',
        scrollTo: "tooltip",
        position: 'left'
      },
      {
        element: '#select-predicao-baixas',
        intro: 'Aqui você poderá selecionar qual Predição de Baixas deseja utilizar na sua Projeção de Brr.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: '#arquivo-capex-projecao-brr',
        intro: 'Aqui você poderá inserir o arquivo de capex.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: '#btn-save-projecao-brr',
        intro: 'Após seleção dos critérios anteriores, clique aqui para salvar e executar sua projeção de brr.',
        scrollTo: "tooltip",
        position: 'left'
      },
    ]
  }),

  computed: {
    title() {
      return this.$route.params.id ? `Editando Projeção de BRR` : 'Adicionar Nova Projeção de BRR';
    }
  },
  
  methods: {
    getById(id) {
      ProjecaoBrrService.getById(id).then(response => {
        this.setDataInVuex(response.data.data);
      })
      .catch(error => {
        console.error(error);
        this.$toast.error('Erro ao recuperar projeção de brr.', '',{position:'topRight'});
      });
    },
  
    salvar() {
      const data = this.$refs.parametrosREF.exportData();
      this.loading = true;
    
      ProjecaoBrrService.salvar(data).then(() => {
        this.$toast.success('Projeção de BRR salva com sucesso.', '',{position:'topRight'})
        this.$router.push({ name: 'Projecao de BRR Historico' });
      })
      .catch(error => {
        console.error(error);
        this.$toast.error('Erro ao salvar Projeção de BRR.', '',{position:'topRight'});
      })
      .finally(() => this.loading = false);
    },
    
    setDataInVuex(item) {
      this.$store.dispatch('setProjecaoBrr', {
        'titulo': item.titulo,
        'movimentacaoBlindada': {
          'id': item.movimentacoes_blindada.id,
          'nome': `#${item.movimentacoes_blindada.id} - ${item.movimentacoes_blindada.titulo}${item.movimentacoes_blindada.versao ? ` (${/^v/i.test(item.movimentacoes_blindada.versao) ? item.movimentacoes_blindada.versao : `v${item.movimentacoes_blindada.versao}`})` : ''}`,
          'data_base': this.formatDateToPicker(item.movimentacoes_blindada.ano_mes_corte_ultimo_ciclo),
          'atualizar_ate': this.formatDateToPicker(item.movimentacoes_blindada.atualizar_ate)
        },
        'simulacaoLaudoIncremental': {
          'id': item.simulacoes_laudos_incrementai.id,
          'nome': `#${item.simulacoes_laudos_incrementai.id} - ${item.simulacoes_laudos_incrementai.titulo}`,
          'data_base': this.formatDateToPicker(item.simulacoes_laudos_incrementai.data_base),
          'data_simulacao_laudo': this.formatDateToPicker(item.simulacoes_laudos_incrementai.data_simulacao_laudo)
        },
        'predicaoBaixas': {
          'id': item.predicoes_baixa.id,
          'nome': `#${item.predicoes_baixa.id} - ${item.predicoes_baixa.titulo}`,
          'data_base': this.formatDateToPicker(item.predicoes_baixa.data_base)
        },
        'arquivoCapex': {
          'id': item.arquivo_capex_id,
          'fileObj': new File([""], item.arquivo_capex.arquivo, { type: "text/csv" }),
          'delimitador': item.arquivo_capex_delimitador,
          'involucro': item.arquivo_capex_involucro,
          'escape': item.arquivo_capex_escape,
          'fakeFile': true,
          'headerValido': true
        }
      });

      this.$forceUpdate();
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      this.iniciarTour(this.arrTour);
    }
  }
}
</script>
